import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { EOfferExtensionType } from '../../types/offer';

export const priceExtensionLabel: TComputedPropMapper<string | undefined> = ({ offer }) => {
  const extension = (offer.extensionLabels || []).find(extension => extension.labelType === EOfferExtensionType.Price);

  return extension && extension.value;
};
